import { render, staticRenderFns } from "./CategoriesDropDown.vue?vue&type=template&id=7664472b&scoped=true&"
import script from "./CategoriesDropDown.vue?vue&type=script&lang=js&"
export * from "./CategoriesDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664472b",
  null
  
)

export default component.exports